import { SiTiktok, SiMeta, SiGoogleads, SiYoutube, SiX, SiFacebook, SiInstagram, SiWhatsapp } from 'react-icons/si';
import { FaLinkedin } from 'react-icons/fa'; // simple-icons dropped LinkedIn (brand rules) — Font Awesome still ships it

// Real platform brand marks, in one place so every surface (hub, segments,
// integrations, Social page) shows the actual logo instead of a stand-in glyph.
// `live` marks which channels Pulse can actually sync today. 'meta' is the ads
// channel; 'facebook'/'instagram' are the organic-social platforms.
export const PLATFORMS = {
  tiktok: { Icon: SiTiktok, label: 'TikTok', color: 'currentColor', live: true },
  meta: { Icon: SiMeta, label: 'Meta', color: '#0866FF', live: true },
  facebook: { Icon: SiFacebook, label: 'Facebook', color: '#1877f2', live: true },
  instagram: { Icon: SiInstagram, label: 'Instagram', color: '#E4405F', live: true },
  google: { Icon: SiGoogleads, label: 'Google Ads', color: '#4285F4', live: true },
  x: { Icon: SiX, label: 'X', color: 'currentColor', live: true },
  whatsapp: { Icon: SiWhatsapp, label: 'WhatsApp', color: '#25D366', live: true },
  linkedin: { Icon: FaLinkedin, label: 'LinkedIn', color: '#0A66C2', live: true },
  youtube: { Icon: SiYoutube, label: 'YouTube', color: '#FF0000', live: false },
};

export default function PlatformIcon({ channel, size = 16, color, style }) {
  const p = PLATFORMS[channel];
  if (!p) return null;
  const Icon = p.Icon;
  return <Icon size={size} style={{ color: color || p.color, flexShrink: 0, verticalAlign: 'text-bottom', ...style }} aria-label={p.label} />;
}
